import React, { useEffect, useState } from "react";
import { StickyContainer, Sticky } from "react-sticky";
import { styled } from "../../stitches.config";
import Title from "../atoms/Title";
import ArticleListItem from "../components/ArticleListItem";
import Avatar from "../atoms/Avatar";
import { bodyLarge, h3, h4Strong } from "../commonStyles/Fonts";
import AuthorLinkIcon from "../assets/icons/author-link-icon.svg";
import ArrowUp from "../assets/icons/arrow-up.svg";
import ArrowDown from "../assets/icons/arrow-down.svg";
import { Author } from "../../api/authors";
import parse from "html-react-parser";
import Breadcrumbs from "../components/Breadcrumbs";
import { withRouter } from "react-router-class-tools";
import { useParams } from "react-router-dom";
import Footer from "../components/Footer"

interface IDescription {
  description: string;
  mail: string;
}

const AuthorDescription: React.FC<IDescription> = ({ description, mail }) => {
  return (
    <>
      <p className={bodyLarge()}>{parse(description)}</p>
      { /* nie wyświetlamy maila do blogów 
      <AuthorContact className={bodyLarge()}>
        <span>
          <a href={`mailto:${mail}`}>{mail}</a>
        </span>
        <button className="author-copy"></button>
      </AuthorContact>
      */ }
    </>
  );
};

const BlogerPage: React.FC = (props) => {
  const [isOpenAuthor, setMobileAuthor] = useState(false);
  const [author, setAuthor] = useState<Author | null>(null);
  const [articles, setArticles] = useState([]);

  const params = useParams();

  useEffect(() => {
    // @ts-ignore
    const { author } = params;
    const fetchUrl = `${window.API_HOST}/pwa-blog/${author}`;

    fetch(fetchUrl)
      .then((response) => {
        return response.ok ? response.json() : Promise.reject(response.status);
      })
      .then((response) => {
        setArticles(response.articles);
        setAuthor(response.author);
      });
  }, []);

  return (
    <>
      <MobileAuthorHeader>
        <Container>
          <AuthorHeader>
            <Avatar border src={author?.img || ""} url={author?.url || ""} />
            <h1 className={h4Strong()}>{author?.name}</h1>
            <img
              className="arrow-icon"
              src={isOpenAuthor ? ArrowUp : ArrowDown}
              onClick={() => setMobileAuthor((prev) => !prev)}
            />
          </AuthorHeader>
          {isOpenAuthor && (
            <AuthorDescription
              description={author?.about || ""}
              mail=""
            />
          )}
        </Container>
      </MobileAuthorHeader>
      <Container>
        <Wrapper>
          <div>
            <Breadcrumbs
              category={{ name: "Stefa blogów", link: "/blogs" }}
              subCategory={{ name: author?.name || "", link: "" }}
              invert
            />

            <Title withDots size="large" type="transparent">
              Moje wpisy
            </Title>
            {articles.map(({ title, intro, link, date }, index) => (
              <>
                <ArticleListItem
                  title={title}
                  lead={intro}
                  url={link}
                  date={date}
                  fullWidth
                  truncatLength={238}
                />
                {index !== articles.length && <Divider />}
              </>
            ))}
          </div>
          <SideSection>
            <StickyContainer style={{ height: "100%" }}>
              <Sticky topOffset={-42} style={{ height: "100%" }}>
                {({ style, isSticky }) => (
                  <StickyWrap isSticky={isSticky} style={style}>
                    <AuthorWrapper>
                      <AuthorHeader>
                        <Avatar
                          border
                          src={author?.img || ""}
                          url={author?.url || ""}
                        />
                        <h1 className={h3()}>{author?.name}</h1>
                      </AuthorHeader>
                      <AuthorDescription
                        description={author?.about || ""}
                        mail=""
                      />
                    </AuthorWrapper>
                  </StickyWrap>
                )}
              </Sticky>
            </StickyContainer>
          </SideSection>
        </Wrapper>
      </Container>
      <Footer />
    </>
  );
};

export default BlogerPage;

const MobileAuthorHeader = styled("div", {
  "@bp4": {
    display: "none",
  },
  "& > div": {
    backgroundColor: "$grayscale10",
    padding: "20px",
  },
  ".arrow-icon": {
    marginLeft: "auto",
    width: "14px",
  },
  p: {
    color: "$grayscale75",
  },
});

const AuthorWrapper = styled("div", {
  backgroundColor: "$grayscale10",
  padding: "24px 16px 40px 16px",
  p: {
    color: "$grayscale75",
  },
});

const AuthorContact = styled("div", {
  color: "$grayscale75",
  "& .author-copy": {
    marginLeft: "8px",
    width: "17px",
    height: "17px",
    backgroundImage: `url("${AuthorLinkIcon}")`,
    backgroundSize: "cover",
    backgroundColor: "$grayscale0",
    borderWidth: "0",
  },
});

const AuthorHeader = styled("div", {
  display: "flex",
  alignItems: "center",
  h1: {
    marginLeft: "16px",
    maxWidth: "min-content",
  },
});

const Divider = styled("div", {
  margin: "24px 0",
  background: "$grayscale10",
  width: "100%",
  height: "1px",
});

const Wrapper = styled("div", {
  "@bp4": {
    display: "grid",
    gridTemplateColumns: "auto 300px",
    gap: "130px",
  },
});

const StickyWrap = styled("div", {
  variants: {
    isSticky: {
      true: {
        paddingTop: "42px"
      },
      false: {}
    }
  }
});

const SideSection = styled("div", {
  display: "none",
  height: "100%",
  "@bp4": {
    display: "block",
    alignSelf: "flex-start",
    paddingTop: "42px",
  },
});

const Container = styled("div", {
  backgroundColor: "$grayscale0",
  padding: "34px 16px 36px 16px",
  "@bp4": {
    padding: "50px 84px 78px 84px",
  },
  a: {
    color: "$grayscale75",
  },
});
